// extracted by mini-css-extract-plugin
export var li = "_vs-2";
export var ol = "_vs-1";
export var ul = "_vs-0";